import ECommerceSettingsStatusCassette from "../ECommerceSettingsStatusCassette";
import useActiveStatus from "./useActiveStatus";

const ActiveStatus = () => {
   const settings = useActiveStatus();

    return (
        <ECommerceSettingsStatusCassette
            settings={settings}
        />
    );
};

export default ActiveStatus;
